/**
 * Returns true if the given value is a recognized "true" string.
 */
export default function coerceIsTrue(
  value: unknown,
  truthy: string[] = ['true', '1', 'yes'],
): boolean {
  if (typeof value !== 'string') return false;
  return truthy.includes(value.toLowerCase());
}
